import { useQuery } from '@tanstack/react-query';
import { fetchGraphMe, type GraphMe } from '@/services/graph/me';

// Signed-in user's name + photo from Microsoft Graph, for the header avatar.
// Best-effort and non-blocking: never retries (a missing Graph token isn't
// transient here) and cached for the session so the photo loads once.
export function useGraphProfile() {
  return useQuery<GraphMe>({
    queryKey: ['graphMe'],
    queryFn: fetchGraphMe,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
